import './card.scss';
export default function Card({children,className}){

	return(
		<div className={`vpe-card${className ? ` ${className}`:''}`}>
			{children}
		</div>
	)
}